<div [ngClass]="{'page-container': currentPortal !== PortalType.Normal}">

  <!--  Action Buttons-->
  <div class="flex justify-end m2">
    <button class="m-r-15" mat-raised-button color="accent" (click)="onClickImportApplications()">
      <mat-icon>arrow_upward</mat-icon>
      Import Applications
    </button>

    <div class="m-r-15">
      <button mat-raised-button color="accent" [matMenuTriggerFor]="newAppMenu" class="dual-icon-button">
        <mat-icon>add</mat-icon>
        <span class="text">New Application</span>
        <mat-icon class="last-icon">arrow_drop_down</mat-icon>
      </button>
    </div>

    <!-- Dropdown Menu -->
    <mat-menu #newAppMenu="matMenu">
      <button mat-menu-item (click)="onClickGroupApplication()">
        <mat-icon>group</mat-icon>
        Group Application
      </button>
      <button mat-menu-item (click)="onClickIndividualApplication()">
        <mat-icon>person</mat-icon>
        Individual Application
      </button>
    </mat-menu>

    <!-- Display Button Other then Broker Portal-->
    <ng-container *ngIf="currentPortal !== PortalType.Broker">
      <button mat-raised-button color="primary" (click)="onClickAddDependent()">
        <mat-icon>add</mat-icon>
        Add Dependent
      </button>
    </ng-container>
  </div>

  <!--  Filters-->
  <div class="clearfix">
    <div class="col col-12">
      <div [formGroup]="searchFormGroup" class="flex justify-start items-end">

        <div class="flex justify-between items-center mr1">
          <greydom-element-input label="Search Application"
                                 formControlName="searchApplication"
                                 [includeDebounceTime]="true"
                                 (valueChange)="onValueChanged($event)">
          </greydom-element-input>
          <mat-icon class="info-icon"
                    matTooltip="Search applications by application ID, reference no., membership no., last name, product code, policyholder group no. or broker no.">
            help_outline
          </mat-icon>
        </div>

        <div class="flex justify-between items-center mr1">
          <greydom-element-input label="Batch Reference No"
                                 formControlName="batchReferenceNumber"
                                 matTooltip="Search applications by batch reference no."
                                 [includeDebounceTime]="true"
                                 (valueChange)="onBatchReferenceChanged($event)">
          </greydom-element-input>
        </div>

        <app-element-select class="ml2"
                            displayLabel='Status'
                            qaAttr="qa-status"
                            [defaultValue]="status"
                            [options]="statusesLookUpValues"
                            (selectionChanged)="onStatusChanged($event)">
        </app-element-select>

        <app-product-filter class="ml2"
                           [selectedProducts]="products"
                           (productChanged)="onProductChanged($event)">
        </app-product-filter>
      </div>
    </div>
  </div>

  <!--  Table-->
  <section class="mat-elevation-z8 table-container">
    <table (matSortChange)="sortData($event)" [dataSource]="dataSource"
           mat-table matSort multiTemplateDataRows>

      <ng-container [matColumnDef]="tableColumns.Icons">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let row" mat-cell>
          <greydom-icon-navigate *ngIf="isReviewIconEnabled(row)"
                                 [icon]="DisplayIcon.ReviewIcon"
                                 [route]="[getRouteForReview(row.applicationId)]"
                                 customTooltip="REVIEW Application">
          </greydom-icon-navigate>
          <div class="flex row">
            <greydom-icon-navigate *ngIf="isEditIconEnabled(row)"
                                   [icon]="DisplayIcon.Edit"
                                   [route]="[getRouteForEditApplication(row.employerGroup?.employerGroupCode), row.applicationId]"
                                   customTooltip="CONTINUE Application">
            </greydom-icon-navigate>
            <mat-icon matTooltip="NTU Application"
                      class="block-icon"
                      *ngIf="isCancelIconEnabled(row)"
                      (click)="archiveApplication(row)">
              {{ DisplayIcon.CancelIcon }}
            </mat-icon>
          </div>

          <mat-icon *ngIf="isEditHelpIconEnabled(row)"
                    class="info-icon info-icon-no-margin"
                    [matTooltip]="'This application is in progress by ' + row.createdBy">
            help_outline
          </mat-icon>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.ApplicationId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
        <td *matCellDef="let element" mat-cell> {{ element.applicationId }}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.ApplicationDate">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Application Date</th>
        <td *matCellDef="let element" mat-cell> {{ element.membership?.applicationDate | date: dateFormat }}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.ApplicationReferenceNumber">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Reference Number</th>
        <td *matCellDef="let element" mat-cell> {{ element.applicationReferenceNumber }}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.MembershipNumber">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Membership Number</th>
        <td *matCellDef="let element" mat-cell> {{ element.membership?.membershipNumber }}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.PrincipalLastName">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Principal Last Name</th>
        <td *matCellDef="let element" mat-cell> {{ element.membership?.principalLastName }}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.SchemeName">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Scheme</th>
        <td *matCellDef="let element" mat-cell> {{ element.scheme?.schemeName }}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.OptionCode">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Product</th>
        <td *matCellDef="let element" mat-cell> {{ element.membership?.optionCode }}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.EmployerGroupName">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Policyholder Group</th>
        <td *matCellDef="let element" mat-cell> {{ element.employerGroup?.employerGroupName }}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.IntermediatoryName">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Broker</th>
        <td *matCellDef="let element" mat-cell> {{ element.intermediatory?.intermediatoryName }}</td>
      </ng-container>


      <ng-container [matColumnDef]="tableColumns.StageName">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Stage</th>
        <td *matCellDef="let element" mat-cell> {{ element.stage?.stageName }}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.StatusName">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Status</th>
        <td *matCellDef="let element" mat-cell>
          <div *ngIf="element.status?.statusName" class="flex justify-start">
            <greydom-status-indicator
              [fillColor]="getStatusColor(element.status.statusName)"></greydom-status-indicator>
            <span class="m-l-5">{{ element.status.statusName }}</span></div>
        </td>
      </ng-container>

      <!-- Expanded Row -->
      <ng-container matColumnDef="expandedDetail">
        <td *matCellDef="let row" [attr.colspan]="displayedColumns.length" mat-cell>
          <div [@detailExpand]="row == expandedElement ? 'expanded' : 'collapsed'"
               class="row-detail-container">
            <b>Batch Reference No:</b> {{ row.batchReferenceNumber }}<br>
            <b>Created By: </b>{{ row.createdBy }}<br>
            <b>Created Date: </b>{{ row.created | date: dateTimeFormat }}<br>
            <b>Updated By: </b>{{ row.updatedBy }}<br>
            <b>Updated Date: </b>{{ row.updated | date: dateTimeFormat }}<br>
          </div>
        </td>
      </ng-container>


      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr (click)="expandedElement = expandedElement === row ? null : row"
          *matRowDef="let row; columns: displayedColumns;"
          [class.expanded-row]="expandedElement == row" class="row"
          mat-row>
      </tr>
      <tr *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row" mat-row></tr>
    </table>

    <mat-paginator #paginator
                   [pageIndex]="0"
                   [length]="applicationTableControl.length"
                   [pageSize]="applicationTableControl.pageSize"
                   [pageSizeOptions]="applicationTableControl.pageSizeOptions"
                   (page)="pageChanged($event)">
    </mat-paginator>
  </section>
</div>
